<template>
    <div class="menu tab_action  tab_bg" >
        <div class="backtop"  >
            <span @click="EditBack" class="backbtn"> <i class="iconfont icon-31fanhui1"></i> 返回</span>
            <span class="btncenter">{{tab==0?'换装':(tab==1?'动作':'角色使用声明')}}</span>
        </div>
        <div class="back_tab">
         
            <span :class="{'back_tab_active':tab==0}" @click="tab=0" v-if="isShowClothes" >换装</span>
            <span :class="{'back_tab_active':tab==1}" @click="tab=1" v-if="isShowAaction">动作</span>
            
            <span :class="{'back_tab_active':tab==2}" @click="tab=2">声明</span>
            <!-- <span :class="{'back_tab_active':tab==3}" v-if="user.type==1" @click="tab=3">上传配件</span> -->
            <span :class="{'back_tab_active':tab==4}" @click="tab=4">调试</span>
         
         
        </div>
        
        
        <div v-if="tab==0">
            <center v-if="user.type!=1"><img src="@/assets/images/null.png"/><div>当前角色暂时不支持换装</div></center>      
            <TabClothes v-if="user.type==1" :modelClass="modelClass" :user="user"  ref="tabClothes" ></TabClothes>
        </div>
        <div >
            <TabAction :t9render="t9render" v-show="tab==1" :modelClass="modelClass" :user="user" ref="action" @isAction="isAction"></TabAction>
        </div>
        <div  v-if="tab==2" class="varbox">
            <div>本角色由 <span class="pink">{{user.userName}}创建人</span> {{user.createDate}}上传；</div>
            <div>为 <span class="pink">{{user.userName}}创建人</span> {{user.rolesSource==1?'原创':'转载'}}角色，来源于{{user.sourceIntroduction}}</div>
            <div>使用规则如下：</div>
            <div><i class="iconfont icon-zhengque" v-if="user.isCommercial==1"></i><i class="iconfont icon-cuowu" v-else></i><span>{{user.isCommercial==1?'':'不'}}允许商用</span></div>
            <div><i class="iconfont icon-zhengque" v-if="user.isCreation==1"></i><i class="iconfont icon-cuowu" v-else></i><span>{{user.isCreation==1?'':'不'}}允许二次创作</span> </div>
            <div><i class="iconfont icon-zhengque" v-if="user.isModify==1"></i><i class="iconfont icon-cuowu" v-else></i><span>{{user.isModify==1?'':'不'}}允许修改模型</span></div>
            <div><i class="iconfont icon-zhengque" v-if="user.isLive==1"></i><i class="iconfont icon-cuowu" v-else></i><span>{{user.isLive==1?'':'不'}}允许用于直播</span></div>
            <!-- <div>同意并遵守《<a href="https://www.live2d.jp/terms/live2d-free-material-license-agreement/" target="_blank">Live2D免费使用条款</a>》</div> -->
        </div>
         
         <div v-if="tab==3">
             <TabUploadClothes :modelClass="modelClass" :user="user"></TabUploadClothes>
         </div>
         <div v-if="tab==4">
             <TabAdjust :modelClass="modelClass" :user="user"></TabAdjust>
         </div>
        
      </div>
</template>

<script>


import TabAction from './TabAction.vue'
import TabClothes from './TabClothes.vue'
import TabAdjust from './TabAdjust.vue'
import TabUploadClothes from './../../clothes/UploadClothes.vue'
export default { 
  name: 'Menu',
  props:["modelClass",'user'],
  components: {
    TabAction,TabClothes,TabAdjust,TabUploadClothes
  },
  data(){
    return {
        tab:0,
        isShowClothes:true,
        isShowAaction:false
    }
  },
    created(){
    
        if(this.user.type==2){
            this.isShowClothes=false;
            this.tab=1;
        }
        if(!this.isShowClothes&&!this.isShowAaction){
                 
             this.tab=2
        }
            
    },
    mounted () {
        
    },
    methods:{
            EditBack(){
                this.$emit("close")
            },
            isAction(){
                this.isShowAaction=true;
       
                if(!this.isShowClothes&&!this.isShowAaction){
                    
                    this.tab=2
                }
                if(!this.isShowClothes&&this.isShowAaction){
                    this.tab=1
                }
            }
    },
 

}
</script>
<style lang="scss" scoped>
.menu {
    position: absolute;
    top: -64px;
    top:0;
    width: 100%;
    left: 0;
  
    height: calc(100% + 64px);
    // background: #fff;
    .varbox {
        padding: 20px 0;
        line-height: 1.5em;
        // padding-left: 0;
        border-radius: 20px;
        div {
            display: flex;
            align-items: center;
            margin-bottom: 5px;
            line-height: 30px;
          
        }
        .pink {
                color: #f4acb7;
                margin: 0 5px;
        }
        .iconfont {
            margin-bottom: 0;
            margin-right: 4px;
            font-size: 20px !important;
        }
        .icon-cuowu {
            color: #EE012E;
        }
        .icon-zhengque {
                color: #01A411;
        }
    }
    // .content-box {
    //     margin: 0!important;
    // }
}

.tab_active {
    border: 3px solid #f4acb7;
    box-sizing: border-box;
}

</style>